export function isNeedAddLineBreak(title: string) {
  return title.length > 25 && title.includes(' ') && !isHasLineBreaks(title);
}

export function isHasLineBreaks(title: string) {
  const trimmed = title.replace(/\s/g, '');
  return trimmed.includes('<br>') || trimmed.includes('<br/>');
}
